import { baseApi } from "./baseApi";
import { supabase } from "../lib/supabaseClient";

export const filmsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getPopularFilms: builder.query<any[], void>({
      queryFn: async () => {
        try {
          const { data, error } = await supabase.from("popular_films").select("*");
          if (error) throw error;
          return { data: data || [] };
        } catch (error: any) {
          return { error: { status: 500, statusText: error.message, data: error } };
        }
      },
      providesTags: ["Film"],
      keepUnusedDataFor: 300, // Cache for 5 minutes
    }),
    getFilmDetails: builder.query<any, string>({
      queryFn: async (imdbId) => {
        try {
          const { data, error } = await supabase.from("films").select("*").eq("imdb_id", imdbId).single();
          if (error) throw error;
          return { data };
        } catch (error: any) {
          return { error: { status: 500, statusText: error.message, data: error } };
        }
      },
      providesTags: (result, error, arg) => [{ type: "Film", id: arg }],
    }),
    searchFilms: builder.query<any[], { query: string; limit?: number }>({
      queryFn: async ({ query, limit = 10 }) => {
        try {
          if (!query || query.length < 2) return { data: [] };
          const { data, error } = await supabase.from("films").select("*").ilike("original_title", `%${query}%`).limit(limit);
          if (error) throw error;
          return { data: data || [] };
        } catch (error: any) {
           return { error: { status: 500, statusText: error.message, data: error } };
        }
      },
    }),
    searchFilmsFull: builder.query<any[], string>({
      queryFn: async (query) => {
        try {
          if (!query || query.length < 2) return { data: [] };
          const { data, error } = await supabase.functions.invoke("search-films", {
            body: { query: query.trim() },
          });
          if (error) throw error;
          return { data: data?.results || [] };
        } catch (error: any) {
          return { error: { status: 500, statusText: error.message, data: error } };
        }
      },
    }),
  }),
});

export const { useGetPopularFilmsQuery, useGetFilmDetailsQuery, useSearchFilmsQuery, useLazySearchFilmsQuery, useSearchFilmsFullQuery } = filmsApi;
